module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/discovery-ui/images/app-store-badges/apple-app-store-fr-089cf53467aeae06eeaa27f2317bbeb1.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/discovery-ui/images/app-store-badges/apple-app-store-fr.svg
// module id = cN9g
// module chunks = 24